// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconHeartSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 59 53"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.433 18.563c0-4.012 3.28-7.25 7.309-7.25 2.774 0 5.745 1.468 7.2 3.927 1.454-2.46 4.424-3.928 7.199-3.928 4.031 0 7.308 3.24 7.308 7.25 0 2.243-.776 4.49-1.893 6.562-1.12 2.079-2.613 4.034-4.118 5.71a39.88 39.88 0 01-4.266 4.104c-.61.5-1.153.907-1.581 1.193-.19.128-.386.245-.588.352-.087.045-.181.09-.277.125a1.25 1.25 0 01-.425.08h-2.72a1.251 1.251 0 01-.424-.08 2.388 2.388 0 01-.278-.125 6.38 6.38 0 01-.585-.352 20.482 20.482 0 01-1.584-1.193 39.995 39.995 0 01-4.265-4.103c-1.505-1.677-2.998-3.632-4.117-5.711-1.12-2.072-1.895-4.32-1.895-6.561zm15.415 0h-1.813c0-3.089-3.087-5.438-6.293-5.438-3.045 0-5.495 2.441-5.495 5.438 0 1.836.64 3.78 1.677 5.702 1.032 1.914 2.43 3.752 3.872 5.361a38.197 38.197 0 004.066 3.911c.58.475 1.07.843 1.435 1.084.134.092.274.177.418.254h2.452c2.15-1.54 4.134-3.3 5.92-5.249 1.443-1.608 2.84-3.447 3.873-5.361 1.034-1.922 1.676-3.866 1.676-5.703 0-2.996-2.452-5.437-5.495-5.437-3.206 0-6.293 2.349-6.293 5.438z"
      />
    </svg>
  )
}
